import React from "react";
import "../CSS/Map.css";

const MapSection = () => {
  return (
    <section className="map-container" id="location">
      <h2 className="section-heading">📍 Our College Location</h2>

      <div className="map-bus-wrapper">
        {/* Left: Map */}
        <div className="map-responsive">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3915.822957781784!2d76.92370437587836!3d10.870188089283525!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba844af9f0b5e05%3A0xa0477f770d2d5116!2sNehru%20Institute%20of%20Engineering%20and%20Technology!5e0!3m2!1sen!2sin!4v1712564226232!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="NIET Location"
          ></iframe>
        </div>

        {/* Right: Local Buses */}
        <div className="bus-info">
          <h3>🚌 Local Buses Available</h3>
          <ul>
            <li><strong>Bus 3E:</strong> Gandhipuram ➝ Nehru College</li>
            <li><strong>Bus 3S:</strong> Gandhipuram ➝ Nehru College</li>
            <li><strong>Bus 96:</strong> Gandhipuram ➝ Nehru College</li>
            <li><strong>Bus 101B:</strong> Gandhipuram ➝ Nehru College</li>
            <li><strong>Bus 101:</strong> Gandhipuram ➝ Nehru College</li>
            <li><strong>Bus 48:</strong> Gandhipuram ➝ College (Every 30 mins)</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
